<template>
    <div class="app-container">
        <breadcrumb-fe :navSource="nav_source"></breadcrumb-fe>
        <tabs ref="tabs" :tab-name="stageName"></tabs>
        <el-form ref="dataForm" :model="temp" style="width: 1000px;">
            <el-form-item label="报考热度">
                <ul class="startsWrap" v-if="checkPermission(['query.edit_archives_admin'])">
                    <li v-for="(item, i) in list" :key="i" @click="handleStarts(i)">
                        <img :src="star > i ? star_yellow : star_gray" />
                    </li>
                </ul>
                <ul class="startsWrap" v-else>
                    <li v-for="(item, i) in list" :key="i">
                        <img :src="star > i ? star_yellow : star_gray" />
                    </li>
                </ul>
            </el-form-item>
            <el-form-item class="normal">
                <Editor v-model="temp.analysis"></Editor>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-permission="['query.edit_archives_admin']">
            <el-button type="primary" @click="saveData">保存</el-button>
        </div>
    </div>
</template>

<script>
import BreadcrumbFe from "@/components/BreadcrumbFe";
import Tabs from "./components/Tabs";
import checkPermission from "@/utils/permission";
import Editor from "@/components/Editor";
import { getAnalysisDetail, editAnalysis } from "@/api/colleges";

export default {
    name: "AnalysisIndex",
    data() {
        return {
            school_uuid: "",
            nav_source: null,
            stageName: "analysis",
            temp: {
                heat: "",
                analysis: ""
            },
            list: [1, 2, 3, 4, 5],
            star_gray: "https://oss.kaoyanvip.cn/attach/file1583143071418.png",
            star_yellow:
                "https://oss.kaoyanvip.cn/attach/file1583144328541.png",
            star: 0
        };
    },
    components: {
        BreadcrumbFe,
        Editor,
        Tabs
    },
    created() {
        this.school_uuid = localStorage.getItem("school_uuid");
        // 面包屑
        let school_name = localStorage.getItem("school_name"),
            school_path = localStorage.getItem("school_path");
        this.nav_source = [
            { title: school_name, path: school_path },
            { title: "院校档案", path: "" }
        ];
        getAnalysisDetail(this.school_uuid).then(res => {
            this.temp.analysis = res.data.analysis;
            this.star = res.data.heat;
        });
    },
    methods: {
        checkPermission,
        // 报考热度星星
        handleStarts(i) {
            this.star = i + 1;
        },

        //保存
        saveData() {
            this.temp.heat = this.star;
            editAnalysis(this.school_uuid, this.temp).then(() => {
                this.$notify({
                    title: "成功",
                    message: "修改成功",
                    type: "success"
                });
            });
        }
    }
};
</script>
<style lang="less" scoped>
.app-container {
    padding-top: 10px;
}
ul,
li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.startsWrap {
    display: flex;
    li {
        padding: 7px 2px;
        height: 22px;
        img {
            width: 22px;
            height: 22px;
        }
    }
}
</style>